// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"column_listContainer__xgDyi","header":"column_header__w5jd7","footerLinks":"column_footerLinks__q6HqV"};